<template>
  <div class="bottom-container" :style="pageStyle">
    <div class="page-content flex-row">
      <template v-for="item in componentParams">
        <div class="list-item">
          <component :is="item.instance" :data="item.data" @navigate="listClick" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import common from '@/assets/common'
  export default {
    name: 'bttom',
    props: {
    },
    data() {
      return {
        pageStyle: {},
        viewList: [],
      }
    },
    computed: {
      componentParams() {
        let {
          viewList
        } = this
        return viewList.map(item => {
          if (!item.instance) {
            item.instance = () => import(`@/components/${item.name}`)
          }
          return item
        })
      }
    },
    created() {
      this.getApi()
    },
    methods: {
      listClick(e){
         // type: 0 当前窗口router，1 当前窗口https链接，2 新窗口https链接
      	if(!e.url) return
        if(e.url == '/' || e.url == '/index'){
          this.$router.push({
            path: e.url,
            query: {
              website_id: this.websiteId
            }
          })
          return
        }
      	if(e.type == 1 || e.type == 3){
          window.location.href = e.url
          return
        }
        if(e.type == 2){
          window.open(e.url)
          return
        }
        this.$router.push({path: e.url})
      },
      getApi() {
        this.$api.get('/api/web_list_temp/get_pc_temp',{
          params:{
            page_type: 4
          },
        }).then(res => {
          const data = res.data
          if(!data) return
          this.pageStyle = common.toPageStyle(data.pageStyle)
          this.viewList = data.viewList
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .bottom-container {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    // overflow-x: hidden;
    overflow: hidden;
  }
  .page-content{
    width: var(--width);
    min-width: var(--width);
    flex-wrap: wrap;
  }
  .list-item {
    display: inline-flex;
  }
</style>



// WEBPACK FOOTER //
// src/layout/bottom.vue